import React from 'react'

import { ConfigurableTable } from '../../../../../utils/wrapper'
import { useConfigContext } from '../../../../ui-config'
import { useDeliveryForecastDespatchAdviceItemById } from '../../../data'

type Props = {
  despatchAdviceId: string
  id: string
}

export const Position: React.FC<Props> = ({ despatchAdviceId, id }) => {
  const { uiConfig: config } = useConfigContext()
  const { data: deliveryForecastDespatchAdviceItem, isLoading } =
    useDeliveryForecastDespatchAdviceItemById(despatchAdviceId, id)

  return (
    <ConfigurableTable
      dataKey="BuyerProductId"
      config={
        config.deliveryForecastDespatchAdvice
          .acceptDeliveryForecastDespatchAdvice.table
      }
      data={[deliveryForecastDespatchAdviceItem]}
      isLoading={isLoading}
      stateKey=""
    />
  )
}
